import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  // ResponsiveContainer,
  PieChart,
  Pie,
  Cell
} from 'recharts'

const OverdueFindingsChartWidget = ({totalCounts, selectedOverdueThreshold} :any) => {
  let totalCount = totalCounts.allRegionsTotalFindingsCount || totalCounts.allDivisionsTotalFindingsCount
  let overdueCount = totalCounts.allRegionsOverdueFindingsCount || totalCounts.allDivisionsOverdueFindingsCount
  let completeCount = totalCount - overdueCount

  let overduePercentage = 0

  if (totalCount > 0) {
    overduePercentage = parseFloat(((overdueCount / totalCount) * 100).toFixed(1))
  }
  let completePercentage = parseFloat((100 - overduePercentage).toFixed(1))

  const data = [
    {
      name: 'overdue',
      count: overdueCount,
      percentage: overduePercentage,
      color: '#FF4C51'
    },
    {
      name: 'complete',
      count: completeCount,
      percentage: completePercentage,
      color: '#28C76F'
    },
  ];
  
  return (
    <>
      <div className="overdue-findings-chart-widget">
        <header className="overdue-findings-chart-widget__header">
          <h2 className="overdue-findings-chart-widget__title">Overdue Findings</h2>
          <h2 className="overdue-findings-chart-widget__totalCount">{totalCounts.allRegionsOverdueFindingsCount || totalCounts.allDivisionsOverdueFindingsCount}</h2>
        </header>

        <div>
          <div className="overdue-findings-chart-widget__body">
            <div className="overdue-findings-chart-widget__content">
              <section className="overdue-findings-chart-widget__content-chart">
                <PieChart width={400} height={250}>
                  <Pie data={data} nameKey={"name"} dataKey={"count"} cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#82ca9d" label>
                  {data.map((ele:any, index:any) => (
                    <Cell key={`cell-${index}`} fill={ele.color} />
                  ))}
                  </Pie>
                </PieChart>
              </section>

              <section className="overdue-findings-chart-widget__content-text">
                <div className="overdue-findings-chart-widget__content-text-overdue">
                  <div className="overdue-findings-chart-widget__content-text-overdue-left">
                    <FontAwesomeIcon icon={faCircle} color={"red"}/>
                    <section>
                      <h3>{`Overdue ( > ${selectedOverdueThreshold} days)`}</h3>
                      <h5>Not completed within timeframe</h5>
                    </section>
                  </div>

                  <div className="overdue-findings-chart-widget__content-text-overdue-right">
                    <div>
                      <h3>{overdueCount}</h3>
                    </div>
                    <div>
                      <h3>{overduePercentage}%</h3>
                    </div>
                  </div>
                </div>

                <div className="overdue-findings-chart-widget__content-text-complete">
                  <div className="overdue-findings-chart-widget__content-text-complete-left">
                    <FontAwesomeIcon icon={faCircle} color={"green"}/>
                    <section>
                      <h3>{`Completed on time`}</h3>
                      <h5>Comleted within timeframe</h5>
                    </section>
                  </div>

                  <div className="overdue-findings-chart-widget__content-text-complete-right">
                    <div>
                      <h3>{completeCount}</h3>
                    </div>
                    <div>
                      <h3>{completePercentage}%</h3>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default OverdueFindingsChartWidget